import "./status-legend.scss";

/* eslint-disable-next-line */
export interface StatusLegendProps {}

export function StatusLegend() {
  const statusItems = [
    {
      color: "bg-blue-500",
      label: "PENDING",
      description: "Awaiting approval",
    },
    {
      color: "bg-green-500",
      label: "APPROVE",
      description: "Approved registration",
    },
    {
      color: "bg-red-500",
      label: "DECLINE",
      description: "Declined registration",
    },
  ];

  return (
    <div id="StatusLegend" className="status-legend">
      <div className="mb-4 p-3 bg-gray-50">
        <h4 className="text-sm font-semibold text-gray-700 mb-2">
          Status Legend:
        </h4>
        <div className="space-y-1">
          {statusItems.map((item) => (
            <div key={item.label} className="flex items-center gap-2">
              <div className={`w-3 h-3 ${item.color} rounded`}></div>
              <span className="text-xs text-gray-600">
                {item.label} - {item.description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default StatusLegend;
